import {
  authentication,
  AuthenticationStorage,
  createDirectus,
  rest,
} from '@directus/sdk';
import { environment } from '../../../environments/environment';
import { BossAuthTokenService } from '../services/boss-auth-token.service';
import { ofetch } from 'ofetch';
import WebSocket from 'ws';

export const bossTokenService = new BossAuthTokenService();

const directusInstance = createDirectus(environment.apiUrl);
export const directusAuthInstance = createDirectus(environment.apiUrl, {
  globals: {
    WebSocket: WebSocket,
    fetch: ofetch,
  },
})
  .with(
    authentication('json', {
      storage: bossTokenService as AuthenticationStorage,
      autoRefresh: true,
      credentials: 'include',
    }),
  )
  .with(rest());

export default directusInstance;
